/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MenuOrderDiscount } from './MenuOrderDiscount';
import {
    MenuOrderDiscountFromJSON,
    MenuOrderDiscountFromJSONTyped,
    MenuOrderDiscountToJSON,
    MenuOrderDiscountToJSONTyped,
} from './MenuOrderDiscount';

/**
 * 
 * @export
 * @interface GetMenuOrderDiscountsResponse
 */
export interface GetMenuOrderDiscountsResponse {
    /**
     * 
     * @type {Array<MenuOrderDiscount>}
     * @memberof GetMenuOrderDiscountsResponse
     */
    discounts: Array<MenuOrderDiscount>;
}

/**
 * Check if a given object implements the GetMenuOrderDiscountsResponse interface.
 */
export function instanceOfGetMenuOrderDiscountsResponse(value: object): value is GetMenuOrderDiscountsResponse {
    if (!('discounts' in value) || value['discounts'] === undefined) return false;
    return true;
}

export function GetMenuOrderDiscountsResponseFromJSON(json: any): GetMenuOrderDiscountsResponse {
    return GetMenuOrderDiscountsResponseFromJSONTyped(json, false);
}

export function GetMenuOrderDiscountsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuOrderDiscountsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'discounts': ((json['discounts'] as Array<any>).map(MenuOrderDiscountFromJSON)),
    };
}

export function GetMenuOrderDiscountsResponseToJSON(json: any): GetMenuOrderDiscountsResponse {
    return GetMenuOrderDiscountsResponseToJSONTyped(json, false);
}

export function GetMenuOrderDiscountsResponseToJSONTyped(value?: GetMenuOrderDiscountsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discounts': ((value['discounts'] as Array<any>).map(MenuOrderDiscountToJSON)),
    };
}

